import { render, staticRenderFns } from "./Sex.vue?vue&type=template&id=59a54175&"
import script from "./Sex.vue?vue&type=script&lang=js&"
export * from "./Sex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports